import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    contentBtn: {
        marginTop: 30,
        marginBottom: 10,
        paddingHorizontal: 25,
        width: 350
    },
    btn: {
        padding: 10,
        borderRadius: 4,
        backgroundColor: '#077A97'
    },
    textBtn: {
        color: '#fff',
        justifyContent: 'center',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: '500'
    }
});

export default styles;
